import React, { useEffect, useState } from 'react';
import LineupTitle from '../lineup-title/lineup-title';
import SingerSwiper from '../singer-swiper/singer-swiper';
import SingerCard from '../singer-card/singer-card';
import { Image } from '../../../../components/image/image';

interface Singer {
  id: number;
  name: string;
  imageUrl: string;
  category: string;
}

interface LineupSectionProps {
  singers?: Singer[];
}

const defaultSingers: Singer[] = [
  {
    id: 1,
    name: 'Ca sĩ 1',
    imageUrl: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/01.png',
    category: 'CA SĨ'
  },
  {
    id: 2,
    name: 'Ca sĩ 2',
    imageUrl: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/02.png',
    category: 'CA SĨ 1'
  },
  {
    id: 3,
    name: 'Ca sĩ 3',
    imageUrl: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/03.png',
    category: 'CA SĨ'
  },
  {
    id: 4,
    name: 'Ca sĩ 4',
    imageUrl: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/01.png',
    category: 'CA SĨ'
  },
  {
    id: 5,
    name: 'Ca sĩ 5',
    imageUrl: 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/artists/02.png',
    category: 'CA SĨ'
  }
];

const LineupSection: React.FC<LineupSectionProps> = ({ singers = defaultSingers }) => {
  const [isSectionInViewPort, setIsSectionInViewPort] = useState<boolean>(false)

  useEffect(() => {
      const handleScroll = () => {
        const section = document.getElementById('lineup-section');
        if (section) {
          const sectionTop = section.getBoundingClientRect().top;
          const windowHeight = window.innerHeight;

          if (sectionTop <= windowHeight) {
            setIsSectionInViewPort(true);
          } else {
            setIsSectionInViewPort(false);
          }
        }
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll(); // Check initial state

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    const handleRenderCard = (singer: Singer, isMobile?: boolean) => {
      return <SingerCard singer={singer} variant={isMobile ? 'small' : 'medium'} />
    }

  return (
    // Add overflow-x-hidden to the main section to prevent horizontal scroll
    <section id='lineup-section' className="relative w-full max-w-[2000px] mx-auto h-full max-h-[820px] overflow-hidden">
      {/* Background container with overflow hidden */}
      <div className="absolute inset-0 overflow-hidden">
        {/* Background tổng - Concert background - Responsive scaling (Layer 1 - Dưới cùng) */}
        <div className="absolute inset-0">
          <Image
            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/lineup-section-background.webp"
            alt="Concert Background"
            fill
            className="object-cover object-center sm:object-bottom scale-100 sm:scale-125 md:scale-150 translate-y-0 sm:translate-y-[8%] md:translate-y-[16.67%]"
            priority
          />
        </div>

        {/* Bottom Background 1 - Responsive height (Layer 2 - Giữa) */}
        <div className="absolute inset-x-0 bottom-0 h-2/3 sm:h-1/2">
          <Image
            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/lineup-bottom-background-1.webp"
            alt="Bottom Background 1"
            fill
            className="object-cover object-center"
          />
        </div>

        {/* Bottom Background 2 - Responsive height with blending (Layer 3 - Trên cùng trong background) */}
        <div className="absolute inset-x-0 bottom-0 h-2/3 sm:h-1/2">
          <Image
            src="https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/lineup-bottom-background-2.webp"
            alt="Bottom Background 2"
            fill
            className="object-cover object-top mix-blend-color-dodge opacity-90"
          />
        </div>

        {/* Floating particles effect - Responsive density (Layer 4 - Trên backgrounds) */}
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(15)].map((_, i) => (
            <div
              key={i}
              className={`absolute w-0.5 h-0.5 sm:w-1 sm:h-1 bg-white/20 rounded-full animate-float ${
                i >= 8 ? 'hidden sm:block' : ''
              } ${i >= 12 ? 'hidden lg:block' : ''}`}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${3 + Math.random() * 4}s`
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Main content container - Full screen height */}
      <div className="relative z-30 h-full flex flex-col items-center justify-center px-0 pb-[34px]">

        {/* Lineup title - Responsive spacing */}
        <div className="mt-4 md:!mt-[77px] mb:2 md:!mb-0">
          <LineupTitle />
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 md:w-24 lg:w-32 bg-gradient-to-r from-purple-400 to-yellow-400 mx-auto mt-3 sm:mt-4 md:mt-5 lg:mt-6 rounded-full"></div>
        </div>

        {/*
          Singer cards swiper container
          This div now has NO overflow-hidden and NO padding
        */}
        <div className="w-full max-w-[1200px] mx-auto">
          <SingerSwiper
            singers={singers}
            renderCard={handleRenderCard}
            autoPlay={true}
            autoPlayInterval={3000}
            isSectionInViewPort={isSectionInViewPort}
          />
        </div>
      </div>
    </section>
  );
};

export default LineupSection;
